module.exports = __webpack_public_path__ + "static/media/ic_cell.a24f2f90.svg";